import {
  AppBar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Tab,
  Tabs,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import defaultAvatar from '../../assets/img/default-avatar.png';
import Button from '../Button';
import { UserInfoDto } from '../../models/APIModels';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { saveUserInfo } from '../../store/slices/userInfo';
import { allowedFileTypes, resizeFile } from '../../Utils/imageUtils';

import { ApiHelper } from '../../common/ApiHelper';
import { useAppDispatch } from '../../store';
import useAppUtils from '../../Utils/useAppUtils';
import UserPeferences from '../UserPeferences';
import Loader from '../Loader';
import Progress from '../Loaders/Progress';

interface IProps {
  open: boolean;
  onClose: () => void;
  userInfo: UserInfoDto;
  // onSave: (model: ModelDefinitionDto) => void;
  // isSaving: boolean;
}
interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const ProfileModalNewUser = ({ open, onClose, userInfo }: IProps) => {
  const [tabValue, setTabValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) setTabValue(newValue);
  };
  const [thumbnailUrl, setThumbnailUrl] = useState();
  // const { userInfo } = useSelector(userInfoSelector);
  const hiddenFileInput = React.useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { alert } = useAppUtils();
  const Mobile = useMediaQuery('(min-width:600px)');
  const Desktop = useMediaQuery('(min-width:1200px)');

  const userFormValues = useForm<UserInfoDto>({
    defaultValues: useMemo(() => {
      // console.log('userInfo', userInfo);
      return userInfo;
    }, [userInfo]),
  });
  const {
    register,
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    reset,
    watch,
    setError
  } = userFormValues;

  const handleChangeIndex = (index: number) => {
    setTabValue(index);
  };

  const getInputLableProps = (value: string) => {
    // console.log(value)
    if (value) {
      return { shrink: true };
    }
    return {};
  };

  const handleImageChange = async (event) => {
    try {
      const file = event.target.files[0];
      const fileExtension = file.name.split('.').at(-1);
      if (allowedFileTypes.includes(fileExtension)) {
        const image = await resizeFile(file);
        setValue('base64ProfilePhoto', image);
        setThumbnailUrl(image);
      }
    } catch (err) {
      alert('Unable to process your request.', 'error');
    }
  };

  const imageOnClickHandler = () => {
    hiddenFileInput.current.click();
  };

  const handleNext: SubmitHandler<UserInfoDto> = () => {
    // console.log('errors', errors);
    if (tabValue === 0) {
      setTabValue(1);
    }
  };

  const handleSave: SubmitHandler<UserInfoDto> = async (data: UserInfoDto) => {
    // console.log('errors', errors);
    if (tabValue === 1) {
      // console.log('data', data);
      try {
        setIsLoading(true);
        data.displayName = `${userInfo?.firstName} ${userInfo?.lastName}`;
        const res = await ApiHelper.UpsertUserInfo(data);
        dispatch(saveUserInfo(res.data));
        setIsLoading(false);
        if (res.status === 200) {
          setIsLoading(false);
          alert('Profile Updated Successfully.');
          onClose();
        } else {
          alert('Unable to process your request.', 'error');
        }
      } catch (e) {
        setIsLoading(false);
        if (e && e.response && e.response.data && e.response.status === 409) {
          console.log('errors', errors);
          setTabValue(0);
          setError("publicName", {
            type: "manual",
            message: e.response.data,
          })
          alert(e.response.data, 'error');
          return;
        }
        alert('Unable to process your request.', 'error');
      }
    }
  };

  const showError = (errors) => {
    if (errors['publicName']) {
      const message = errors.publicName.message ? errors.publicName.message : 'User Name is required';
      return message;
    }
    return '';
  }

  useEffect(() => {
    // console.log('userInfo changed', userInfo);
  }, [userInfo])

  return (
    <>
      <Dialog open={open} maxWidth="md" fullWidth={true}>
        <h3 style={{ textAlign: 'center', paddingTop: '20px', marginBottom: '5px' }}>
          <b>BUILD</b> YOUR PROFILE <br />
          <small style={{ fontSize: '60%', color: '#999', fontWeight: '500', lineHeight: 1 }}>
            This information will let us know more about you.
          </small>
        </h3>
        <FormProvider {...userFormValues}>
          <DialogContent sx={{ padding: '0 !important', minHeight: '40vh' }}>
            
            {isLoading && <Progress  progressLabel='Please wait we are updating your profile ...'/>}
            <Box sx={{ bgcolor: 'background.paper' }}>
              <AppBar position="static">
                <Tabs
                  value={tabValue}
                  onChange={handleChange}
                  indicatorColor="secondary"
                  textColor="inherit"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                >
                  <Tab label="Account" {...a11yProps(0)} />
                  <Tab label="Preferences" {...a11yProps(1)} />
                  {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
                </Tabs>
              </AppBar>
              <div>
                <TabPanel value={tabValue} index={0}>
              {Mobile &&    <h4 className="info-text" style={{ textAlign: 'center', marginTop: '0px', marginBottom:'20px', textTransform:'none' }}>
                    {' '}
                    Let's start with some basic information
                  </h4>}
              {!Mobile &&    <h6 className="info-text" style={{ textAlign: 'center', marginTop: '0px', marginBottom:'20px', textTransform:'none' }}>
                    {' '}
                    Let's start with some basic information
                  </h6>}
                 {Mobile && <>
                  <Grid container spacing={2}>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={4} sx={{margin:'auto'}}>
                      {/* <Item>xs=4</Item> */}
                      <div className="picture-container" style={{ position: 'relative', cursor: 'pointer', textAlign: 'center', alignContent:'center' }}>
                        <div
                          className="picture"
                          style={{
                            width: '106px',
                            height: '106px',
                            background: '#999',
                            border: '4px solid #ccc',
                            color: '#fff',
                            borderRadius: '50%',
                            margin: '5px auto',
                            overflow: 'hidden',
                            transition: 'all .2s',
                          }}
                          onClick={imageOnClickHandler}
                        >
                          <input
                            type="file"
                            accept="image/jpeg, image/png"
                            ref={hiddenFileInput}
                            style={{ display: 'none' }}
                            onChange={handleImageChange}
                            // disabled={!isPrivate}
                          />
                          <img src={thumbnailUrl || defaultAvatar} alt="profile-pic" loading="lazy" />
                        </div>
                        <h6>Choose Picture</h6>
                      </div>
                    </Grid>
                    <Grid item xs={6} container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Username (public)"
                          variant="outlined"
                          size="small"
                          disabled={false}
                          placeholder="Enter a unique username"
                          {...register('publicName', { required: true })}
                          error={Boolean(errors['publicName'])}
                          // required
                          inputProps={{
                            maxLength: 250,
                          }}
                          helperText={showError(errors)}
                          InputLabelProps={getInputLableProps(getValues('publicName'))}
                        ></TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Email Address"
                          variant="outlined"
                          size="small"
                          disabled={false}
                          placeholder="Enter Email"
                          {...register('email', { required: true })}
                          error={Boolean(errors['email'])}
                          // required
                          inputProps={{
                            maxLength: 250,
                          }}
                          helperText={errors['email'] ? 'Email is required' : ''}
                          InputLabelProps={getInputLableProps(getValues('email'))}
                        ></TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="First Name"
                          variant="outlined"
                          size="small"
                          disabled={false}
                          placeholder="Enter First Name"
                          {...register('firstName', { required: true })}
                          error={Boolean(errors['firstName'])}
                          // required
                          inputProps={{
                            maxLength: 50,
                          }}
                          helperText={errors['firstName'] ? 'First Name is required' : ''}
                          InputLabelProps={getInputLableProps(getValues('firstName'))}
                        ></TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Last Name"
                          variant="outlined"
                          size="small"
                          disabled={false}
                          placeholder="Enter Last Name"
                          {...register('lastName', { required: true })}
                          error={Boolean(errors['lastName'])}
                          // required
                          inputProps={{
                            maxLength: 50,
                          }}
                          helperText={errors['lastName'] ? 'Last Name is required' : ''}
                          InputLabelProps={getInputLableProps(getValues('lastName'))}
                        ></TextField>
                      </Grid>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={10}>
                      <TextField
                        fullWidth
                        label="About Me (Within 150 characters)"
                        variant="outlined"
                        size="small"
                        disabled={false}
                        placeholder="Enter About Me"
                        {...register('aboutMe', { required: false })}
                        error={Boolean(errors['aboutMe'])}
                        // required
                        inputProps={{
                          maxLength: 150,
                        }}
                        // helperText={errors['aboutMe'] ? 'Last Name is required' : ''}
                        multiline
                        minRows={3}
                        maxRows={5}
                        InputLabelProps={getInputLableProps(getValues('aboutMe'))}
                      ></TextField>
                    </Grid>
                    <Grid item xs={1}></Grid>
                  </Grid>
                 </>}
                 {!Mobile &&<>
                  <Grid container spacing={2}>
                  
                    <Grid item xs={12} sx={{margin:'auto'}}>
                      {/* <Item>xs=4</Item> */}
                      <div className="picture-container" style={{ position: 'relative', cursor: 'pointer', textAlign: 'center', alignContent:'center' }}>
                        <div
                          className="picture"
                          style={{
                            width: '106px',
                            height: '106px',
                            background: '#999',
                            border: '4px solid #ccc',
                            color: '#fff',
                            borderRadius: '50%',
                            margin: '5px auto',
                            overflow: 'hidden',
                            transition: 'all .2s',
                          }}
                          onClick={imageOnClickHandler}
                        >
                          <input
                            type="file"
                            accept="image/jpeg, image/png"
                            ref={hiddenFileInput}
                            style={{ display: 'none' }}
                            onChange={handleImageChange}
                            // disabled={!isPrivate}
                          />
                          <img src={thumbnailUrl || defaultAvatar} alt="profile-pic" loading="lazy" />
                        </div>
                        <h6>Choose Picture</h6>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Username (public)"
                          variant="outlined"
                          size="small"
                          disabled={false}
                          placeholder="Enter a unique username"
                          {...register('publicName', { required: true })}
                          error={Boolean(errors['publicName'])}
                          // required
                          inputProps={{
                            maxLength: 250,
                          }}
                          helperText={showError(errors)}
                          InputLabelProps={getInputLableProps(getValues('publicName'))}
                        ></TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Email Address"
                          variant="outlined"
                          size="small"
                          disabled={false}
                          placeholder="Enter Email"
                          {...register('email', { required: true })}
                          error={Boolean(errors['email'])}
                          // required
                          inputProps={{
                            maxLength: 250,
                          }}
                          helperText={errors['email'] ? 'Email is required' : ''}
                          InputLabelProps={getInputLableProps(getValues('email'))}
                        ></TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="First Name"
                          variant="outlined"
                          size="small"
                          disabled={false}
                          placeholder="Enter First Name"
                          {...register('firstName', { required: true })}
                          error={Boolean(errors['firstName'])}
                          // required
                          inputProps={{
                            maxLength: 50,
                          }}
                          helperText={errors['firstName'] ? 'First Name is required' : ''}
                          InputLabelProps={getInputLableProps(getValues('firstName'))}
                        ></TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Last Name"
                          variant="outlined"
                          size="small"
                          disabled={false}
                          placeholder="Enter Last Name"
                          {...register('lastName', { required: true })}
                          error={Boolean(errors['lastName'])}
                          // required
                          inputProps={{
                            maxLength: 50,
                          }}
                          helperText={errors['lastName'] ? 'Last Name is required' : ''}
                          InputLabelProps={getInputLableProps(getValues('lastName'))}
                        ></TextField>
                      </Grid>
                  
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="About Me (Within 150 characters)"
                        variant="outlined"
                        size="small"
                        disabled={false}
                        placeholder="Enter About Me"
                        {...register('aboutMe', { required: false })}
                        error={Boolean(errors['aboutMe'])}
                        // required
                        inputProps={{
                          maxLength: 150,
                        }}
                        // helperText={errors['aboutMe'] ? 'Last Name is required' : ''}
                        multiline
                        minRows={3}
                        maxRows={5}
                        InputLabelProps={getInputLableProps(getValues('aboutMe'))}
                      ></TextField>
                    </Grid>
                    
                  </Grid>
                 </>}
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                      <UserPeferences/>
                </TabPanel>
              </div>
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: Mobile ? 'right' : "center" }}>
          {tabValue === 0 && (
              <Button  variant="contained" rounded onClick={handleSubmit(handleNext)} sx={{ width: '250px' }}>
                Next
              </Button>
            )}
            {tabValue === 1 && (
              <Button variant="contained" rounded onClick={handleSubmit(handleSave)} sx={{ width: '250px' }}>
                Save
              </Button>
            )}
          
          </DialogActions>
        </FormProvider>
      </Dialog>
    </>
  );
};

export default ProfileModalNewUser;
